import React from "react";

// Compact BPM / Camelot key / energy readout with an analysis-status dot.
// Shared between the normal playlist rows and the DJ queue panel.
const TrackAnalysisChip = ({ features }) => {
  const bpm = features?.bpm;
  const camelot = features?.camelot;
  const energy = features?.energy;

  let dotClass;
  let dotTitle;
  if (!features) {
    dotClass = "bg-neutral-600 animate-pulse";
    dotTitle = "Not analyzed yet";
  } else if (bpm && camelot && energy != null) {
    dotClass = "bg-emerald-500";
    dotTitle = "Fully analyzed";
  } else if (bpm) {
    dotClass = "bg-amber-500";
    dotTitle = "BPM only — key/energy missing";
  } else {
    dotClass = "bg-neutral-600";
    dotTitle = "No analysis";
  }

  return (
    <div
      className="flex flex-col items-end justify-center font-mono tabular-nums leading-tight min-w-[44px]"
      title={dotTitle}
    >
      <div className="flex items-center gap-1">
        <span className={`w-1.5 h-1.5 rounded-full ${dotClass}`} />
        <span className="text-[11px] text-text">{bpm ? Math.round(bpm) : "—"}</span>
      </div>
      <div className="text-[10px] text-text-muted">
        {camelot || "—"}
        {" · "}
        {energy != null ? energy.toFixed(2) : "—"}
      </div>
    </div>
  );
};

export default TrackAnalysisChip;
